<template>
  <div>
    <el-dialog title="费用报销明细" :visible.sync="dialogVisible" :close-on-click-modal="false" width="500px">
      <div style="height: 500px;overflow-y: scroll">
        <el-descriptions title="年度累计" column=1>
          <el-descriptions-item label="预算金额">{{ yearData.yearMoney }}元</el-descriptions-item>
          <el-descriptions-item label="已报金额">{{ yearData.year_expenses_jine }}元</el-descriptions-item>
          <el-descriptions-item label="可报金额">{{ yearData.year_usable_jine }}元</el-descriptions-item>
          <el-descriptions-item label="">({{ yearData.year_applyed_jine }}[已申请]-{{ yearData.year_expenses_jine }}[已报]-{{ yearData.year_frozen_jine }}[报销冻结])</el-descriptions-item>
          <el-descriptions-item label="可申请金额">{{ yearData.year_can_jine }}元</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="本月" column="1">
          <el-descriptions-item label="预算金额">{{ monthData.month_jine }}元</el-descriptions-item>
          <el-descriptions-item label="已报金额">{{ monthData.month_expenses_jine }}元</el-descriptions-item>
          <el-descriptions-item label="可报金额">{{ monthData.month_usable_jine }}元</el-descriptions-item>
<!--          <el-descriptions-item label="可挪用金额">{{ monthData.month_can_jine }}元</el-descriptions-item>-->
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;callback=undefined">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "InfoExpenseAccount",
  data(){
    return{
      dialogVisible:false,
      tree_str:"",
      id:"",
      tree_obj:{},
      name:"id",
      value:"",
      callback:null,
      yearData: {},
      monthData: {},
    }
  },
  mounted() {

  },
  methods:{
    show(config,callback){
      console.info(config)
      const that = this;
      that.dialogVisible=true;
      that.callback=callback;
      let budgetUrl = window.Glob.budget;
      Http.get(budgetUrl + "/admin/BudgetSendApi/sendMoneyDetail?",config,function (res) {
        if (res.code) {
          that.yearData = res.data.year_data
          that.monthData = res.data.month_data
        }
      })
    },

    selectItem(data){
      const that = this;
      typeof that.callback==="function"&&that.callback(data)
      that.dialogVisible=false;
      that.callback=undefined;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/InfoExpenseAccount.vue